


























import Vue from "vue";
import Emoji from "@/components/Emoji.vue";
import Pagination from "@/components/detail/Pagination.vue";
import CommentInput from "@/components/detail/CommentInput.vue";
import SubCommentItem from "@/components/detail/SubCommentItem.vue";
import { formatPublishTime } from "@/utils/filters";
import feedMixin from "@/mixins/feed";
import ssoMixin from "@/mixins/sso";
import { ICommentParams } from "@/types/post";

export default Vue.extend({
  name: "comment-item",
  mixins: [feedMixin, ssoMixin],
  filters: {
    formatPublishTime,
  },
  components: {
    Emoji,
    Pagination,
    CommentInput,
    SubCommentItem,
  },
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
    from: {
      type: String,
      default: "",
    },
    tid: {
      type: String,
      default: "",
    },
    replyInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      loading: false,
      expanded: false,
    };
  },
  computed: {
    curUser() {
      return this.$store.state.user.curUser;
    },
    hasLogin() {
      return this.curUser.userId !== "0";
    },
    feedComment() {
      return this.$store.state.post.feedComment;
    },
    users() {
      return this.feedComment.users;
    },
  },
  mounted() {},
  methods: {
    stat(action: string, data: any) {
      this.$stat("xiaozhan", action, data);
    },
    async getCommentList(page_token = "1") {
      const tid = this.tid;
      const params: ICommentParams = {
        tid,
        reply_cid: this.replyInfo.commentId,
        page_token,
      };
      try {
        const result = await this.$store.dispatch(
          "post/fetchFeedSubComment",
          params
        );

        this.loading = false;
        return result;
      } catch (e) {
        this.loading = false;
        this.$message({
          type: "warning",
          message: "拉取数据失败",
        });
      }
    },
    handlePageChange(page: string, limit: string) {
      const pageToken = Number(page);
      this.stat("xiaozhan_comment_section_more_click", { button: "turn_page" });
      this.getCommentList(pageToken);
    },
    async handleCommentExpand() {
      this.expanded = true;
      this.stat("xiaozhan_comment_section_more_click", { button: "see" });
      await this.getCommentList();
    },
  },
});
